import { ReactElement } from 'react'

import { Link } from 'react-router-dom'

import { Flex } from 'components/core'
import { campaignUrl } from 'routing/urls'

import { SelectedSearchTerm } from '../localTypes'
import * as styles from '../styles.scss'

interface Props {
    selectedSearchTerm: SelectedSearchTerm
}

const CampaignLabel = ({
    selectedSearchTerm: {
        record: { campaign },
    },
}: Props): ReactElement => (
    <Flex direction="column" alignItems="normal">
        <div className={styles.label}>Source Campaign</div>
        <div className={styles.value}>
            <Link to={campaignUrl(campaign.id)}>{campaign.name}</Link>
        </div>
    </Flex>
)

export default CampaignLabel
